import Github from './github.svg';
import Twitter from './twitter.svg';

const Images = {
  Github,
  Twitter,
};

export default Images;
